<template>
    <ValidationObserver ref="formAdd" v-slot="{ validate, reset }">
        <v-form>
            <v-card flat ref="form" class="mt-0">
                <v-card-text class="pa-0 mb-4">
                    <v-col cols="12" class="user-topbar mb-2 pl-0">
                        <h2 class="step_title primary--text font-weight-light mr-3 text-uppercase">Add Identité</h2>
                        <v-spacer />
                        <!-- <v-checkbox v-model="formAdd.isActive" :true-value="1" :false-value="0" class="primary--text" :label="$t('Make default')"></v-checkbox> -->
                    </v-col>

                    <v-col cols="6" class="py-0 pl-0">
                        <ImagePickerInput v-model="formAdd.logoFile"></ImagePickerInput>
                    </v-col>
                </v-card-text>
                <v-card-text class="pa-0 mb-4">
                    <v-row>
                        <v-col cols="6" class="py-0">
                            <p class="label">Société (Expéditeur)</p>
                            <ValidationProvider v-slot="{ errors }" :name="$t('Email')" rules="required">
                                <v-text-field placeholder="" v-model="formAdd.companyName" hide-details="auto" outlined required></v-text-field>
                            </ValidationProvider>
                        </v-col>

                        <v-col cols="6" class="py-0">
                            <p class="label">Adresse</p>
                            <v-text-field placeholder="" v-model="formAdd.address" hide-details="auto" outlined required></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text class="pa-0 mb-4">
                    <v-row>
                       <v-col cols="6" class="py-0">
                            <p class="label">Ville</p>
                            <v-text-field placeholder="" v-model="formAdd.city" hide-details="auto" outlined required></v-text-field>
                        </v-col>

                        <v-col cols="6" class="py-0">
                            <p class="label">Code postal</p>
                            <v-text-field placeholder="" v-model="formAdd.codePostal" hide-details="auto" outlined required></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text class="pa-0 mb-4">
                    <v-row>
                        <v-col cols="6" class="py-0">
                            <p class="label">Pays</p>
                            <CountryPickerInput v-model="formAdd.countryId"></CountryPickerInput>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-text class="pa-0 mb-4">
                    <v-row>
                        <v-col cols="12" class="py-0">
                            <p class="label">Footer</p>
                            <v-textarea
                                    outlined
                                    no-resize
                                    rows="5"
                                    v-model="formAdd.description"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <div class="text-center">
                <v-btn class="ma-2" depressed rounded color="primary" @click.prevent="save" :loading="isInProgressAdd">Enregistrer</v-btn>
                <v-btn class="ma-2  black--text" depressed rounded color="#E1E1E1" @click.prevent="cancel">{{$t('Cancel')}}</v-btn>
            </div>
        </v-form>
    </ValidationObserver>
</template>

<script>
  import { ValidationObserver, ValidationProvider } from "vee-validate";
  import IdentityService from '@/services/identity.service.js';
  import ImagePickerInput from '@/components/inputs/ImagePickerInput.vue';
  import CountryPickerInput from '@/components/inputs/CountryPickerInput.vue';

  export default {
    name: "AddIdentityForm",
    components: {
      ImagePickerInput,
      CountryPickerInput,
      ValidationObserver,
      ValidationProvider
    },
    data: () => ({
      isInProgressAdd: false,
      formAdd: {},
    }),
    created() {
      this.formAdd = IdentityService.getInitFormData();
    },
    methods: {
      async save() {
        if (this.isInProgressAdd) {
          return;
        }

        this.isInProgressAdd = true;

        try {
            const {data} = await IdentityService.create(this.formAdd);
            this.successMessage('Identity created successfully');

            this.$emit('update:added', data);

            if (data.isActive) {
              this.$emit('update:set-default', data.id);
            }
        } catch (e) {
            this.handleError(e);
        }

        this.isInProgressAdd = false;
      },
      cancel() {
        if (this.isInProgressAdd) {
          return;
        }

        this.$emit("update:cancelled");
      }
    }
  }
</script>

<style scoped>

</style>
